import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Navbar } from "shards-react";

//import NavbarSearch from "./NavbarSearch";
import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";

const MainNavbar = ({ stickyTop, toggleSideBar }) => {
  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );

  //<NavbarSearch />
  return (
    <div className={classes}>
      <Navbar type="light" className="align-items-strech flex-md-nowrap p-0 ">
        <NavbarToggle toggleSideBar={toggleSideBar} />
        <NavbarNav />
      </Navbar>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool,
};

MainNavbar.defaultProps = {
  stickyTop: true,
};

export default MainNavbar;
